import React, { FormEvent } from 'react'
import { useDemoRegistration } from '../hooks/useDemoRegistration'
import { DemoSession } from '../types'

type Props = {
  onRegistrationComplete: (session: DemoSession) => void
}

export const DemoRegistrationForm: React.FC<Props> = ({
  onRegistrationComplete,
}) => {
  const { register, isLoading, error } = useDemoRegistration()

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    void (async () => {
      try {
        const session = await register({})
        onRegistrationComplete(session)
      } catch {
        // エラーは useDemoRegistration 内で処理
      }
    })()
  }

  return (
    <form onSubmit={handleSubmit}>
      {error && <div className="alert alert-danger mb-3">{error}</div>}

      <p className="text-muted mb-4">
        ボタンを押すとデモ試験が開始されます。
        <br />
        カメラへのアクセス許可が求められますので、許可してください。
      </p>

      <button
        type="submit"
        className="btn btn-primary btn-lg w-100"
        disabled={isLoading}
      >
        {isLoading ? '準備中...' : 'デモを開始する'}
      </button>
    </form>
  )
}
